<!-- <form class="form-change" [formGroup]="autoCompleteForm"> -->
<mat-form-field appearance="fill">
  @if (value?.id && showProfileImage) {
  <img
    class="profile-image"
    [src]="'https://profile-images.internal.brafton.com/profile-images/profile-image-' + $safeNavigationMigration(value?.id) + '.jpg'"
  />
  }

  <input
    #profileInput
    type="text"
    matInput
    [formControl]="myControl"
    [required]="true"
    placeholder="Select User"
    [matAutocomplete]="autoGroup"
    (blur)="inputTouched()"
    [value]="getInputBoxValue()"
    [disabled]="disabled"
  />
  <!-- (input)="onChange($event.target.value)" -->
  <mat-icon matSuffix>expand_more</mat-icon>
  <mat-autocomplete #autoGroup="matAutocomplete">
    @for (user of filteredUsers | async; track user) {
    <mat-option [value]="user.displayName" (click)="selectUser(user)">
      <!-- <mat-icon *ngIf="showProfileImage">
        </mat-icon> -->
      @if (showProfileImage) {
      <img
        class="profile-image"
        [src]="'https://profile-images.internal.brafton.com/profile-images/profile-image-' + $safeNavigationMigration(user?.id) + '.jpg'"
      />
      } {{user.displayName }}
    </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
<!-- </form> -->
